export var AccountRejectedIA = function AccountRejectedIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REJECTED_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REJECTED_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REJECTED_TITLE = function ACCOUNT_REJECTED_TITLE(strictLocalize) {
  return strictLocalize({
    id: "SQcNcq",
    defaultMessage: [{
      "type": 0,
      "value": "Accountafwijzing"
    }]
  });
};
var ACCOUNT_REJECTED_DESCRIPTION = function ACCOUNT_REJECTED_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x0nDyC",
    defaultMessage: [{
      "type": 0,
      "value": "Helaas kunnen we op dit moment niet verder met je account op Faire. Al je lopende bestellingen worden geannuleerd. Als er al bestellingen zijn verzonden, wordt je hiervoor uitbetaald. We kunnen je op dit moment geen verdere informatie geven. Onze excuses voor het ongemak, maar bedankt voor je begrip."
    }]
  });
};